import { SET_GROUP_MEMBER_DETAILS } from "../type"

export const setGroupMemberDetail = (groupMemberDetails: any) => (dispatch: any) => {
    dispatch({
        type: SET_GROUP_MEMBER_DETAILS,
        payload: {
            groupMemberDetails: groupMemberDetails
        }
    })
}
